var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('small',{staticClass:"hidden-xs-only"},[_vm._v(_vm._s(_vm.currency))]),_c('NumberFormatter',{attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }